// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface RoadBlockIconSignature {
  Element: SVGSVGElement;
}

export const RoadBlockIcon: TOC<RoadBlockIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 6H20V3H18V6H6V3H4V6H3C2.448 6 2 6.447 2 7V13C2 13.553 2.448 14 3 14H4V23H6V20H18V23H20V14H21C21.552 14 22 13.553 22 13V7C22 6.447 21.552 6 21 6ZM14.5 8L13.5 12H9.5L10.5 8H14.5ZM7.5 8H4V12H6.5L7.5 8ZM18 18H6V14H18V18ZM16.5 12H20V8H17.5L16.5 12Z"/>
</svg>
</template>;